import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import RequireAuth from '@rbac/RequireAuth';
import { useCan } from '@rbac/useCan';
import { EmptyState } from '@/components';
import { useModules } from '@/modules';
import Login from '@pages/Login';
import ServiceLayout from './ServiceLayout';
import { visibleServiceRoutes } from './routes';

/**
 * Service / repair partner portal (merchant domain, `/service`). Staff sign in
 * with their merchant account (same JWT, bound to this store). Each screen needs
 * its module in the store's live registry and module:view: with repairs switched
 * off (D101) only the always-on warranty desk is left.
 */
export default function ServiceApp({ store }) {
  const routes = visibleServiceRoutes(useModules(), useCan());
  const home = routes.find((r) => r.nav);
  return (
    <Routes>
      <Route path="/login" element={<Login store={store} />} />
      <Route element={<RequireAuth />}>
        <Route element={<RequireService routes={routes} />}>
          <Route element={<ServiceLayout store={store} routes={routes} />}>
            {routes.map(({ path, Element }) => (
              <Route key={path} path={path} element={<Element store={store} />} />
            ))}
            {/* Inside the guards: signed out goes to /login, no screens shows the empty state. */}
            <Route path="*" element={home ? <Navigate to={home.path} replace /> : null} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

/** The portal needs at least one screen (the server enforces every action; this only avoids a page of errors). */
function RequireService({ routes }) {
  if (routes.length) return <Outlet />;
  return (
    <div className="p-6">
      <EmptyState title="No access to the service portal">Ask the store owner to give your role the Service or Warranty permissions.</EmptyState>
    </div>
  );
}
